export default __webpack_public_path__ + "static/sussex-spaniel-6e4bf64775ab0c04bcf12bff58f18893.jpg";